import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconAward = ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={`${className} ${sizeOption}`}
    >
    <defs>
      <path
        d="M12.3057,16.707 C11.9947,16.536 11.6187,16.539 11.3157,16.72 L7.5677,18.92 L9.0357,13.21 C9.9107,13.71 10.9217,14 11.9997,14 C13.0777,14 14.0887,13.71 14.9647,13.21 L16.4537,19.002 L12.3057,16.707 Z M11.9997,4 C14.2057,4 15.9997,5.794 15.9997,8 C15.9997,10.206 14.2057,12 11.9997,12 C9.7937,12 7.9997,10.206 7.9997,8 C7.9997,5.794 9.7937,4 11.9997,4 L11.9997,4 Z M18.9687,20.751 L16.6597,11.772 C17.4957,10.74 17.9997,9.429 17.9997,8 C17.9997,4.691 15.3087,2 11.9997,2 C8.6917,2 5.9997,4.691 5.9997,8 C5.9997,9.429 6.5037,10.74 7.3397,11.772 L5.0317,20.751 C4.9307,21.143 5.0757,21.556 5.3987,21.799 C5.7207,22.042 6.1587,22.064 6.5057,21.862 L11.8357,18.733 L17.5157,21.875 C17.6667,21.959 17.8337,22 17.9997,22 C18.2167,22 18.4327,21.93 18.6127,21.791 C18.9277,21.547 19.0687,21.138 18.9687,20.751 L18.9687,20.751 Z"
        id="path-dbgwa6g1wu-1"
      />
    </defs>
    <g
      id="\u2B50\uFE0F-[Symbols]-Icons"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon/award">
        <mask id="mask-dbgwa6g1wu-2" fill="white">
          <use xlinkHref="#path-dbgwa6g1wu-1" />
        </mask>
        <use
          id="\uD83C\uDFA8-Icon-\u0421olor"
          fill="#1C1F2B"
          xlinkHref="#path-dbgwa6g1wu-1"
        />
      </g>
    </g>
    </svg>
  )
}
